import {
  createApp
} from "vue";

const app = createApp({
  components: {},
});

app.mount("#app");
